var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 252",
    style: {
      enableBackground: "new 0 0 841.9 252"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2AFA1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.6,4.3h80.2v16.2h-30.9v91.9h-18.3V20.5h-30.9V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.8,112.4h-17.6V105c-4.2,4.9-11.8,9.2-21,9.2c-17.8,0-27.5-11.8-27.5-29.1V34.2h17.6v47.9 c0,9.7,4.6,16,14.6,16c7.6,0,14.3-4.8,16.2-12.5V34.2h17.6V112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.5,52c-2.5-1.8-6.7-2.6-10.4-2.6c-7.2,0-13.9,4.1-15.7,12.5v50.5h-17.6V34.2h17.6v8.1 c3-5.8,9.9-9.9,17.4-9.9c3.9,0,7.4,0.7,8.6,1.4V52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.9,112.4h-17.6V4h17.6v36.9c3.5-4.4,11.3-8.5,19.9-8.5c22.9,0,36.3,18.5,36.3,40.8 c0,22.5-13.4,40.9-36.3,40.9c-8.6,0-16.4-4.1-19.9-8.5V112.4z M592.9,88.1c3,6.2,9.7,10.4,16.9,10.4c13.6,0,21.7-10.7,21.7-25.2 s-8.1-25.2-21.7-25.2c-7.2,0-13.9,4.2-16.9,10.4V88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M668.1,24.1c-5.8,0-10.9-4.8-10.9-10.7c0-6,5.1-10.7,10.9-10.7c5.8,0,10.9,4.8,10.9,10.7 C679.1,19.3,674,24.1,668.1,24.1z M676.9,112.4h-17.6V34.2h17.6V112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691.7,34.2h17.6v7.4c4.2-4.9,12-9.2,21.1-9.2c17.8,0,27.6,11.8,27.6,29.1v50.9h-17.6V64.5 c0-9.7-4.8-16-14.8-16c-7.6,0-14.4,4.8-16.4,12.5v51.4h-17.6V34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M837.2,88.1c-2.6,15.5-14.1,26.1-32.9,26.1c-21.8,0-37-16.6-37-40.7c0-23.4,15.3-41,36.6-41 c22,0,34,15.7,34,38.6v6.3h-53.3c0.5,13.7,8.5,22,19.7,22c8.4,0,14.8-3.7,16.7-11.3H837.2z M785.1,64.5h35.4 c-0.2-9.5-5.6-17.3-16.4-17.3C794.4,47.2,787.2,53.2,785.1,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381,217.6c3.5,11.1,12.7,16.2,24.5,16.2c12.7,0,21-6,21-16c0-7.6-4.4-12-15.7-14.6l-18.3-4.4 c-15-3.5-26.9-11.6-26.9-29.1c0-18.3,15-32,36.8-32c23.4,0,37.2,12,41,29.9H425c-2.8-8.1-9.7-14.4-22.5-14.4 c-11.6,0-19.5,6-19.5,15c0,7.2,4.6,11.8,14.3,14.1l18.8,4.4c16.9,3.9,28,13.7,28,29.9c0,20.2-16.2,32.8-38.6,32.8 c-22.9,0-39.3-11.6-43.1-31.7H381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.8,183.9h-17.3v-14.6h17.3v-21h17.6v21H496v14.6h-17.6v40.5c0,6.3,3.5,9.2,9.3,9.2c3.5,0,7.6-1.4,10-3.2 v16c-3,1.8-7.7,2.8-13.2,2.8c-13.9,0-23.8-7.4-23.8-22.9V183.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M573.6,247.5H556v-7.4c-4.2,4.9-11.8,9.2-21,9.2c-17.8,0-27.5-11.8-27.5-29.1v-50.9h17.6v47.9 c0,9.7,4.6,16,14.6,16c7.6,0,14.3-4.8,16.2-12.5v-51.4h17.6V247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.1,240.8c-3.5,4.4-11.3,8.5-19.9,8.5c-22.9,0-36.3-18.3-36.3-40.9c0-22.4,13.4-40.8,36.3-40.8 c8.6,0,16.4,4.1,19.9,8.5v-36.9h17.6v108.4h-17.6V240.8z M639.1,193.6c-3-6.2-9.7-10.4-16.9-10.4c-13.6,0-21.7,10.7-21.7,25.2 c0,14.4,8.1,25.2,21.7,25.2c7.2,0,13.9-4.2,16.9-10.4V193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.6,159.2c-5.8,0-10.9-4.8-10.9-10.7c0-6,5.1-10.7,10.9-10.7c5.8,0,10.9,4.8,10.9,10.7 C688.5,154.4,683.4,159.2,677.6,159.2z M686.4,247.5h-17.6v-78.2h17.6V247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M733.3,249.3c-22,0-37.2-16.9-37.2-40.9c0-23.9,15.1-40.8,37.2-40.8c22,0,37.2,16.9,37.2,40.8 C770.5,232.4,755.3,249.3,733.3,249.3z M733.3,182.7c-12.7,0-19.5,10.9-19.5,25.7c0,14.8,6.9,25.7,19.5,25.7 c12.7,0,19.5-10.9,19.5-25.7C752.8,193.6,746,182.7,733.3,182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M792.8,225c1.9,6.5,7.7,9.9,15.5,9.9c8.1,0,13.4-3.2,13.4-9.3c0-4.2-2.6-6.5-9.2-8.1l-16.2-3.9 c-11.1-2.6-19.4-8.6-19.4-21.5c0-14.1,12.5-24.5,29.6-24.5c18.3,0,28.7,8.8,31.3,23.1h-17.3c-1.6-5.1-6.2-8.6-14.3-8.6 c-6.2,0-12.5,2.8-12.5,9c0,3.5,2.5,5.8,8.1,7.2l16.6,3.9c13.4,3.2,20.1,10.7,20.1,22.2c0,15.5-12.9,25-30.5,25 c-18.3,0-31-9.2-33.3-24.3H792.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.4,13.3c-5.7-5.7-13.5-9-21.7-9h-71.8H79.4H9.2c-5.3,0-8,6.4-4.2,10.2l65.4,65.4c5.7,5.7,13.5,9,21.7,9 h71.8v71.8c0,8.1,3.2,15.9,9,21.7l65.4,65.4c3.8,3.8,10.2,1.1,10.2-4.2v-70.1V88.8h70.1c5.3,0,8-6.4,4.2-10.2L257.4,13.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b4b484c8198d5a2ec631171da9bde6b.svg";
export { ForwardRef as ReactComponent };